import { type ReactNode, useEffect, useState } from "react";

/**
 * Renders a same-sized placeholder on the server and during the first client
 * paint, then mounts `children` after the browser is idle. Keeps below-fold
 * widgets out of the hydration long-task without a hydration mismatch.
 */
export function DeferIsland({
  children,
  fallback,
}: {
  children: ReactNode;
  fallback: ReactNode;
}) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let idleId = 0;
    let timeoutId = 0;
    const show = () => setReady(true);

    if (typeof window.requestIdleCallback === "function") {
      idleId = window.requestIdleCallback(show, { timeout: 1200 });
    } else {
      timeoutId = window.setTimeout(show, 1);
    }

    return () => {
      if (idleId && typeof window.cancelIdleCallback === "function") {
        window.cancelIdleCallback(idleId);
      }
      if (timeoutId) window.clearTimeout(timeoutId);
    };
  }, []);

  return ready ? children : fallback;
}
